import generic_backend_request_post from 'functions/server/generic_backend_request_post';


async function renameInstance(state, instance_id, newName) {
    /**
     * This function sends a POST request to the backend server to rename an instance.
     * It takes in the state, instance_id, and newName and returns the response from the server.
     * 
     * @param {Object} state - The state object containing the instance data.
     * @param {string} instance_id - The ID of the instance to be renamed.
     * @param {string} newName - The new name for the instance.
     * @returns {Object} - The response from the server.
     */
    if (!instance_id) {
        throw new Error('Instance ID is required for renameInstance')
    }
    if (!newName) {
        throw new Error('New name is required for renameInstance')
    }
    if (!state) {
        throw new Error('State is required for renameInstance')
    }
    const requestJson = {
        "instance_id": instance_id,
        "new_name": newName,
        "state": state
    }
    const retJson = await generic_backend_request_post(requestJson, '/update_instance');
    return retJson;
}

export default renameInstance